import {
  InboxEntryReplyStatePayload,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

const EVENT_TYPE_BY_ACTION: Partial<
  Record<WebSocketAction, WebSocketEventType>
> = {
  [WebSocketAction.INSERT]: WebSocketEventType.INSERT,
  [WebSocketAction.MODIFY]: WebSocketEventType.MODIFY,
};

export function createInboxEntryReplyStateMessageHandler(
  eventEmitter: IEventEmitter,
) {
  return (action: WebSocketAction, item: InboxEntryReplyStatePayload) => {
    try {
      const eventType = EVENT_TYPE_BY_ACTION[action];
      if (!eventType) {
        log.warn(
          '[InboxEntryReplyStateHandler] Unknown action for InboxEntryReplyState:',
          action,
        );
        return;
      }
      log.debug(
        `[InboxEntryReplyStateHandler] ${action} reply state ${item.inboxEntryId}`,
      );
      eventEmitter.emit(
        WebSocketEntityType.InboxEntryReplyState,
        eventType,
        item,
      );
    } catch (error) {
      log.error('[InboxEntryReplyStateHandler] Handler failed:', error);
    }
  };
}
